"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEADER_BUTTON_MODE = exports.HQO_SDK_ACTIONS = void 0;
var HQO_SDK_ACTIONS;
(function (HQO_SDK_ACTIONS) {
    HQO_SDK_ACTIONS["INIT"] = "init";
    HQO_SDK_ACTIONS["GET_JWT"] = "getJWT";
    HQO_SDK_ACTIONS["GET_USER"] = "getUser";
    HQO_SDK_ACTIONS["GET_BUILDING"] = "getBuilding";
    HQO_SDK_ACTIONS["GET_BUILDINGS"] = "getBuildings";
    HQO_SDK_ACTIONS["GET_HOST_INFO"] = "getHostInfo";
    HQO_SDK_ACTIONS["SHOW_NATIVE_PAYMENT"] = "showNativePayment";
    HQO_SDK_ACTIONS["HIDE_NATIVE_PAYMENTS"] = "hideNativePayments";
    HQO_SDK_ACTIONS["GET_PAYMENT_METHODS"] = "getPaymentMethods";
    HQO_SDK_ACTIONS["TOKENIZE_CARD"] = "tokenizeCard";
    HQO_SDK_ACTIONS["SET_STORAGE"] = "setStorage";
    HQO_SDK_ACTIONS["GET_STORAGE"] = "getStorage";
    HQO_SDK_ACTIONS["SET_HEADER"] = "setHeader";
    HQO_SDK_ACTIONS["SHOW_HEADER"] = "showHeader";
    HQO_SDK_ACTIONS["HIDE_HEADER"] = "hideHeader";
    HQO_SDK_ACTIONS["GET_BRAND"] = "getBrand";
    HQO_SDK_ACTIONS["GET_THEME"] = "getTheme";
    HQO_SDK_ACTIONS["SHOW_FOOTER"] = "showFooter";
    HQO_SDK_ACTIONS["HIDE_FOOTER"] = "hideFooter";
    HQO_SDK_ACTIONS["ENABLE_BACK_SWIPE"] = "enableBackSwipe";
    HQO_SDK_ACTIONS["DISABLE_BACK_SWIPE"] = "disableBackSwipe";
    HQO_SDK_ACTIONS["CLOSE_WEB_VIEW"] = "closeWebView";
    HQO_SDK_ACTIONS["LOGOUT"] = "logout";
})(HQO_SDK_ACTIONS = exports.HQO_SDK_ACTIONS || (exports.HQO_SDK_ACTIONS = {}));
var HEADER_BUTTON_MODE;
(function (HEADER_BUTTON_MODE) {
    HEADER_BUTTON_MODE["HISTORY"] = "history";
    HEADER_BUTTON_MODE["CLOSE"] = "close";
})(HEADER_BUTTON_MODE = exports.HEADER_BUTTON_MODE || (exports.HEADER_BUTTON_MODE = {}));
//# sourceMappingURL=sdk-message.types.js.map